// @flow
import { AddIcon, AddRecipeButton, Margin, RecipeListItem, RecipesListContainer } from './style';
import { Content, RecipeItem } from '../recipe-item/style';
import { injectIntl, intlShape } from 'react-intl';

import ImmutablePropTypes from 'react-immutable-proptypes';
import { LoadingIndicator } from '~/components/widgets';
import messages from '../intl';
import Modal from '~/components/widgets/modal';
import { PLUS } from '~/core/constants/icons/general';
import PropTypes from 'prop-types';
import * as React from 'react';
import { recipeItemAnimationDuration } from '../style-variables';
import RecipeModal from '../recipe-modal';
import RecipesItem from '../recipe-item';

RecipesList.propTypes = {
    canAddRecipe: PropTypes.bool.isRequired,
    cancelTemplate: PropTypes.func.isRequired,
    consumerId: PropTypes.string,
    intl: intlShape,
    isFirstLoadingDone: PropTypes.bool,
    modalVisiblePage: PropTypes.number,
    producerId: PropTypes.string,
    readyToSave: PropTypes.bool.isRequired,
    recipes: ImmutablePropTypes.map.isRequired,
    saveRecipe: PropTypes.func.isRequired,
    showTemplateList: PropTypes.func.isRequired
};

function RecipesList({
    canAddRecipe,
    cancelTemplate,
    consumerId,
    intl: { formatMessage },
    isFirstLoadingDone,
    modalVisiblePage,
    producerId,
    readyToSave,
    recipes,
    saveRecipe,
    showTemplateList
}) {
    return (
        <LoadingIndicator isLoading={isFirstLoadingDone}>
            <Margin>
                <RecipesListContainer>
                    {recipes.entrySeq().map(([key, value]) => (
                        <RecipeListItem
                            classNames="animation"
                            key={`recipe#${key}`}
                            timeout={recipeItemAnimationDuration}
                        >
                            <RecipeItem>
                                <RecipesItem recipe={value} />
                            </RecipeItem>
                        </RecipeListItem>
                    ))}
                    {canAddRecipe && (
                        <RecipeItem>
                            <Content onClick={showTemplateList}>
                                <AddRecipeButton>
                                    <div>{formatMessage(messages.addRecipe)}</div>
                                    <AddIcon icon={PLUS} />
                                </AddRecipeButton>
                            </Content>
                        </RecipeItem>
                    )}
                </RecipesListContainer>
            </Margin>
            <Modal
                contentLabel="Actions Modal"
                disableSaveButton={!readyToSave}
                isBig
                isOpen={modalVisiblePage !== null}
                noPadding
                onRequestClose={cancelTemplate}
                onSave={saveRecipe}
            >
                <RecipeModal consumerId={consumerId} producerId={producerId} />
            </Modal>
        </LoadingIndicator>
    );
}

export default injectIntl(RecipesList);



// WEBPACK FOOTER //
// ./src/components/widgets/recipes/recipes-list/component.js